module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"status":"前回捕虫紙交換日:{date}  交換まで{days}日","warning":"前回捕虫紙交換日から{days}日を過ぎています、交換してください。"},"en":{"status":"Trap replaced on {date} ({days} days until next replacement)","warning":"Trap was supposed to be replaced {days} days ago. Please replace the trap."}}')
  delete Component.options._Ctor
}
